import React from 'react';
import PropTypes from 'prop-types';
import ClickOutside from 'react-click-outside';
import HtmlDynamically from './htmlDynamically';
import { Remove } from '../../../resources/images/icons';

const DisplayMessage = props => (
  <ClickOutside onClickOutside={props.closeDisplayMessage}>
    <div className='message-container' onClick={props.closeDisplayMessage}>
      <div className={props.infoMessage.isSuccess ? 'message success' : (props.infoMessage.isPermission ? 'message permission-msg' :'message')}>{props.infoMessage.message}
        <span title= {props.translations['remove']} role='icon'>
          <HtmlDynamically html={Remove} />
        </span>
      </div>
    </div>
  </ClickOutside>
);

DisplayMessage.propTypes = {
  infoMessage: PropTypes.object,
  closeDisplayMessage: PropTypes.func
};

export default DisplayMessage;
